import { StockCountDetail, StockCountList, StockCountState } from './stock-count.interface';
import { LoadStateInitialValue } from 'app/core/interfaces/generic.interface';
import { Definition } from 'app/core/store/definitions/definition.interface';

export const initialState: StockCountState = {
  filter: {
    pageSize: 25,
    pageNumber: 1,
  },
  stockCounts: new LoadStateInitialValue<StockCountList>({
    items: [],
    totalItems: 0,
  }),
  detail: new LoadStateInitialValue<StockCountDetail>(),
  orders: null,
  materials: null,
  shipTos:  new LoadStateInitialValue<Definition[]>(),
};
